<template>
  <div class="mini_chart">
    <canvas :id="'mini_chart_' + sensor.code" width="200" height="100"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js/auto';
  import chartjs_background_color from '@/utils/chartjs_background_color'

  export default {
    name: 'mini_chart',
    props: ['sensor', 'day_stops'],
    data: function() {
      return {
        chart: undefined
      }
    },
    methods: {
      drawChart: async function () {
        const labels = this.sensor.measures.map(m => m.dt);
        const values = this.sensor.measures.map(m => m.value);
        if(this.chart)
          this.chart.destroy();
        this.chart = new Chart('mini_chart_' + this.sensor.code, {
          type: 'line',
          plugins: [chartjs_background_color],
          data: {
            labels: labels,
            datasets: [{
              data: values,
              fill: false,
              lineTension: 0,
              pointRadius: 0,
              borderColor: "#F06D16",
              backgroundColor: "#F06D16",
              borderWidth: 1.5
            }]
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
              x: {
                ticks: {
                  display: false
                },
                grid: {
                  display: false
                }
              }
            },
            chart: {
            },
            plugins: {
              tooltip: {
                enabled: false
              },
              legend: {
                display: false
              },
              chartjs_background_color: {
                stops: this.day_stops,
                color: "#FBFBFB"
              }
            },
            animation: false
          }
        });
      }
    },
    mounted() {
      this.drawChart();
    },
    watch: {
      day_stops: function(){
        this.drawChart();
      }
    }

  }
</script>
